module.exports = __webpack_public_path__ + "img/angular.4ea9dc62.png";